import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrow-loop-left-2', 'ArrowLoopLeft2', [["path",{"d":"M13 21v-6m0 -6v-1a4 4 0 1 1 4 4h-13"}],["path",{"d":"M8 16l-4 -4l4 -4"}]]);